/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIBrandRequest
 */
export interface APIBrandRequest {
    /**
     * 
     * @type {string}
     * @memberof APIBrandRequest
     */
    name: string;
}

/**
 * Check if a given object implements the APIBrandRequest interface.
 */
export function instanceOfAPIBrandRequest(value: object): value is APIBrandRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIBrandRequestFromJSON(json: any): APIBrandRequest {
    return APIBrandRequestFromJSONTyped(json, false);
}

export function APIBrandRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBrandRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function APIBrandRequestToJSON(value?: APIBrandRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

